import { createFileRoute } from '@tanstack/react-router';
import { UsageSettingsPage } from '../../components/settings/usage-settings-page.js';

export const Route = createFileRoute('/settings/usage')({
  component: UsageSettingsPage,
});
